/* eslint-disable no-underscore-dangle */
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import React, { useEffect } from 'react';
import Root from 'client/containers/AppRouter';
import configureStore, { createReduxPersistor } from 'client/_redux/store/configureStore';
import { hydrate } from 'react-dom';
import { RootState } from 'client/_redux/reducers';
import i18n from 'locales';
import { Suspense } from 'react';
import { useSSR } from 'react-i18next';
import { Resource } from 'i18next';
import { AuthProvider } from 'contexts/AuthContext';
import DashboardRoot from 'dashboard/containers/DashboardRouter';
import NotFound from 'client/pages/NotFound';
import { ToastContainer } from 'react-toastify';
// import combinedReducers from 'reducers';
import moment from 'moment';
import 'moment/locale/fr';
import setDefaultOptions from 'date-fns/setDefaultOptions';
import { fr } from 'date-fns/locale';
import '../public/assets/css/index.css';
moment.locale('fr');
setDefaultOptions({ locale: fr });
declare global {
  interface Window {
    __PRELOADED_STATE__?: RootState;
    initialLanguage: string;
    initialI18nStore: Resource;
  }
}

const preloadedState = window.__PRELOADED_STATE__;

delete window.__PRELOADED_STATE__;
const store = configureStore(preloadedState);

createReduxPersistor(store);
if (!i18n.isInitialized) {
  i18n.init();
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
const BaseApp = () => {
  useSSR(window.initialI18nStore, window.initialLanguage);

  return (
    <Suspense fallback={<div>Still loading i18n...</div>}>
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop />

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover
          />
          <Switch>
            <Route path="/dashboard">
              <DashboardRoot />
            </Route>
            <Route path="/">
              <Root />
            </Route>
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
      </Provider>
    </Suspense>
  );
};

hydrate(
  <React.StrictMode>
    <AuthProvider>
      <BaseApp />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept();
}
